module.exports = __webpack_public_path__ + "img/03.a2820fc6.jpg";